/* eslint-disable react/no-deprecated */
// These needs to be "require" instead of "import" for IE11
const React = require('react')
const PropTypes = require('prop-types')

// Some libs an old version of react that requires propTypes
React.PropTypes = PropTypes

//Element.closest() - taken from mdn
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    let el = this

    do {
      if (Element.prototype.matches.call(el, s)) {return el}
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

//Array.from - taken from mdn
if (!Array.from) {
  Array.from = (function() {
    let symbolIterator
    try {
      symbolIterator = Symbol.iterator
        ? Symbol.iterator
        : 'Symbol(Symbol.iterator)'
    } catch (e) {
      symbolIterator = 'Symbol(Symbol.iterator)'
    }

    let toStr = Object.prototype.toString
    let isCallable = function(fn) {
      return (
        typeof fn === 'function' ||
        toStr.call(fn) === '[object Function]'
      )
    }
    let toInteger = function(value) {
      let number = Number(value)
      if (isNaN(number)) {return 0}
      if (number === 0 || !isFinite(number)) {return number}
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number))
    }
    let maxSafeInteger = Math.pow(2, 53) - 1
    let toLength = function(value) {
      let len = toInteger(value)
      return Math.min(Math.max(len, 0), maxSafeInteger)
    }

    let setGetItemHandler = function setGetItemHandler(isIterator, items) {
      let iterator = isIterator && items[symbolIterator]()
      return function getItem(k) {
        return isIterator ? iterator.next() : items[k]
      }
    }

    let getArray = function getArray(
      T,
      A,
      len,
      getItem,
      isIterator,
      mapFn
    ) {
      // 16. Let k be 0.
      let k = 0

      // 17. Repeat, while k < len… or while iterator is done (also steps a - h)
      while (k < len || isIterator) {
        let item = getItem(k)
        let kValue = isIterator ? item.value : item

        if (isIterator && item.done) {
          return A
        } else {
          if (mapFn) {
            A[k] =
              typeof T === 'undefined'
                ? mapFn(kValue, k)
                : mapFn.call(T, kValue, k)
          } else {
            A[k] = kValue
          }
        }
        k += 1
      }

      if (isIterator) {
        throw new TypeError(
          'Array.from: provided arrayLike or iterator has length more then 2 ** 52 - 1'
        )
      } else {
        A.length = len
      }

      return A
    }

    // The length property of the from method is 1.
    return function from(arrayLikeOrIterator /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      let C = this

      // 2. Let items be ToObject(arrayLikeOrIterator).
      let items = Object(arrayLikeOrIterator)
      let isIterator = isCallable(items[symbolIterator])

      // 3. ReturnIfAbrupt(items).
      if (arrayLikeOrIterator == null && !isIterator) {
        throw new TypeError(
          'Array.from requires an array-like object or iterator - not null or undefined'
        )
      }

      // 4. If mapfn is undefined, then let mapping be false.
      let mapFn = arguments.length > 1 ? arguments[1] : void undefined
      let T
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError(
            'Array.from: when provided, the second argument must be a function'
          )
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2]
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      let len = toLength(items.length)

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      let A = isCallable(C) ? Object(new C(len)) : new Array(len)

      return getArray(
        T,
        A,
        len,
        setGetItemHandler(isIterator, items),
        isIterator,
        mapFn
      )
    }
  })()
}

//log dom remove and insert child errors
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) {
      console.error('Cannot remove a child from a different parent', child, this)
      return child
    }
    return originalRemoveChild.apply(this, arguments)
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.error(
        'Cannot insert before a reference node from a different parent',
        referenceNode,
        this
      )
      return newNode
    }
    return originalInsertBefore.apply(this, arguments)
  }
}
